/*
  By: Manohar
  On: 23/10/2026
  Modification: Deleted Cases right drawer (only for INSURANCE HEAD role) to view interactionRemovalLog
*/
import { h } from 'preact';
import { useState, useEffect } from 'preact/hooks';
import axios from 'axios';
import toastr from 'toastr';
import moment from 'moment';
import CONSTANTS from '../../lib/constants';
import { Modal } from '../rightDrawer';

const DeletedCasesDrawer = (props) => {
  const { onClose } = props;

  const [deletedCasesLogs, setDeletedCasesLogs] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const getDeletedCasesLogs = async () => {
    try {
      setIsLoading(true);
      let response = await axios.get(`${CONSTANTS.API_URL}/api/v1/interaction/removalLog`);
      setDeletedCasesLogs(response.data || []);
    } catch (HTTPException) {
      console.error(HTTPException);
      setDeletedCasesLogs([]);
      toastr.error(HTTPException.response && HTTPException.response.data && HTTPException.response.data.message ? HTTPException.response.data.message : 'Failed to fetch deleted cases');
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getDeletedCasesLogs();
  }, []);

  return (
    <div class="visitmodalslide">
      <Modal title="Deleted Cases" modalSize="is-large-filter" isProfileModal isOutsideClickClose
        modalDisplay="show-modal" onClose={(e) => onClose && onClose(e)} >
        <div class="deleted-cases-drawer" onClick={(e) => e.stopPropagation()}>
          <div class="modal-header deleted-cases-header">
            <span class="fs-12">
              <ul class="breadrcrumb_arrows_inverted m-r-8">
                <li>Deleted Cases</li>
              </ul>
            </span>
            {
              !isLoading && (
                <span class="deleted-cases-count">{deletedCasesLogs.length} record(s)</span>
              )
            }
          </div>
          <div class="deleted-cases-body">
            {
              isLoading ? (
                <div class="deleted-cases-loader">
                  <img src="/assets/images/gifs/done.gif" width="200" height="200"/>
                  <p>Fetching Deleted Cases...</p>
                </div>
              ) : (
                deletedCasesLogs.length > 0 ? (
                  <table class="deleted-cases-table">
                    <thead>
                      <tr>
                        <th>Deleted On</th>
                        <th>Interaction UUID</th>
                        <th>VIN</th>
                        <th>Status</th>
                        <th class="text-center">Removed Tasks</th>
                        <th>Deleted By</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        deletedCasesLogs.map((log) => (
                          <tr>
                            <td class="nowrap">{log.createdAt ? moment(log.createdAt).format('DD MMM YYYY, hh:mm A') : '-'}</td>
                            <td class="deleted-cases-uuid">{log.interactionID}</td>
                            <td class="nowrap">{(log.removedInteraction && log.removedInteraction.dynamicProperties_vin) || '-'}</td>
                            <td>
                              <span class={`deleted-cases-status ${log.status === 'removed' ? 'is-removed' : log.status === 'notFound' ? 'is-not-found' : 'is-failed'}`} title={log.errorMessage || ''}>
                                {log.status === 'removed' ? 'Removed' : log.status === 'notFound' ? 'Not found' : 'Failed'}
                              </span>
                            </td>
                            <td class="text-center" title={(log.removedTasks || []).map(task => `${task.displayName} (${task.status})`).join('\n')}>
                              {log.removedTaskCount || 0}
                            </td>
                            <td>{log.createdByName || log.createdByEmail || '-'}</td>
                          </tr>
                        ))
                      }
                    </tbody>
                  </table>
                ) : (
                  <p class="deleted-cases-empty">No deleted cases found</p>
                )
              )
            }
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default DeletedCasesDrawer;
